import GA from 'springload-analytics.js';

import onPageReady from './utils/onPageReady';
import polyfill from './polyfills/polyfill-loader';

import initMainMenu from './modules/main-menu';
import initPouMenu from './modules/pou-menu';
import initProfileMenu from './modules/profile-menu';
import initStore from './modules/store';
import initRemoveViewAsQuery from './modules/remove-view-as-query';

const sentryDsn = 'https://402ee708a9044e0694faa1f6b0158f6d@o37692.ingest.sentry.io/5387370';

function initialise() {
    GA.init();
    initMainMenu();
    initPouMenu();
    initProfileMenu();
    initRemoveViewAsQuery();
    const globalMobxStore = initStore();

    if (navigator.userAgent.includes('MSIE') || navigator.appVersion.includes('Trident/')) {
        import(/* webpackChunkName: "ie-11" */ './modules/ie11.js')
            .then(({ default: ie11Init }) => {
                ie11Init();
            });
    }

    if (sentryDsn) {
        import(/* webpackChunkName: "sentry" */ './modules/sentry.js')
            .then(({ default: sentry }) => {
                sentry.init(sentryDsn);
            });
    }

    /*  Tables  ------------------------ */
    const tables = document.querySelectorAll('table');
    if (tables.length > 0) {
        import(/* webpackChunkName: "tables" */ './modules/responsive-tables.js')
            .then(({ default: tablesInit }) => {
                tablesInit([...tables]);
            });
    }

    /*  Collapsibles  ------------------------ */
    const collapsibleEls = document.querySelectorAll('.main-menu-secondary__title, [data-collapse-control], .collapse-control');
    if (collapsibleEls.length > 0) {
        import(/* webpackChunkName: "collapsible" */ './modules/collapsible.js')
            .then(({ default: collapsibleInit }) => {
                collapsibleInit([...collapsibleEls]);
            });
    }

    /*  Commentaries  ------------------------ */
    const commentaryEls = document.querySelectorAll('[data-commentary]');
    if (commentaryEls.length > 0) {
        import(/* webpackChunkName: "commentaries" */ './modules/commentaries.js')
            .then(({ default: commentaryInit }) => {
                commentaryInit([...commentaryEls], globalMobxStore);
            });
    }

    /*  Metrics  -------------------- */
    const metricEls = document.querySelectorAll('[data-metric]');
    if (metricEls.length > 0) {
        import(/* webpackChunkName: "goals" */ './modules/metrics.js')
            .then(({ default: metricInit }) => {
                metricInit([...metricEls], globalMobxStore);
            });
    }

    /*  Publish Controls  -------------------- */
    const publishControlEls = document.querySelectorAll('[data-publish-control]');
    if (publishControlEls.length > 0) {
        import(/* webpackChunkName: "goals" */ './modules/indicator-publish-control.js')
            .then(({ default: publishControlInit }) => {
                publishControlInit([...publishControlEls], globalMobxStore);
            });
    }

    /*  Iwi Selector  ------------------------ */
    const headerSelector = document.querySelectorAll('.header-iwi-select');
    if (headerSelector) {
        import(/* webpackChunkName: "iwi-select" */ './modules/header-selector.js')
            .then(({ default: selectorInit }) => {
                headerSelector.forEach((el) => {
                    selectorInit(el, globalMobxStore);
                });
            });
    }

    /*  Iwi Search  ------------------------ */
    const searchEls = document.querySelectorAll('[data-search]');
    if (searchEls.length > 0) {
        import(/* webpackChunkName: "iwi-search" */ './modules/search.js')
            .then(({ default: searchInit }) => {
                searchInit(searchEls, globalMobxStore);
            });
    }

    /*  Iwi Dashboard  ------------------------ */
    const dashboardMountNode = document.getElementById('dashboard-app');
    if (dashboardMountNode) {
        import(/* webpackChunkName: "dashboard" */ './modules/dashboard.js')
            .then(({ default: init }) => init(dashboardMountNode, globalMobxStore));
    }

    /*  Iwi Dashboard  ------------------------ */
    const editBannerMountNode = document.getElementById('edit-banner-app');
    if (editBannerMountNode) {
        import(/* webpackChunkName: "dashboard" */ './modules/edit-banner-app.js')
            .then(({ default: init }) => init(editBannerMountNode, globalMobxStore));
    }

    /*  Covid 19 Vaccination App  ------------------------ */
    const covidVaxMountNode = document.getElementById('covid-vaccination-mount-node');
    if (covidVaxMountNode) {
        import(/* webpackChunkName: "covid-vaccination" */ './modules/covid-vaccination.js')
            .then(({ default: init }) => init(covidVaxMountNode, globalMobxStore));
    }

    /*  Hauora Hub Vaccination App  ------------------------ */
    const hauoraHubMountNode = document.getElementById('hauora-hub-mount-node');
    if (hauoraHubMountNode) {
        import(/* webpackChunkName: "hauora-hub" */ './modules/hauora-hub.js')
            .then(({ default: init }) => init(hauoraHubMountNode, globalMobxStore));
    }

    /*  Area of Interest App  ------------------------ */
    const areaOfInterestMountNode = document.getElementById('area-of-interest-mount-node');
    if (areaOfInterestMountNode) {
        import(/* webpackChunkName: "area-of-interest" */ './modules/area-of-interest.js')
            .then(({ default: init }) => init(areaOfInterestMountNode, globalMobxStore));
    }

    /*  Census Data available Banner  ------------------------ */
    const bannerCensusSelector = document.getElementById('census-banner');
    if (bannerCensusSelector) {
        import(/* webpackChunkName: "census-banner" */ './modules/census-banner.js')
            .then(({ default: init }) => init(bannerCensusSelector, globalMobxStore));
    }
}

polyfill().then(() => onPageReady(initialise));
